webpackJsonp([213720915766396],{

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: ', ';\n  line-height: 1.2;\n  margin: 0 0 10px;\n  ', ';\n'], ['\n  color: ', ';\n  font-size: ', ';\n  line-height: 1.2;\n  margin: 0 0 10px;\n  ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    font-size: ', ';\n  '], ['\n    font-size: ', ';\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _style = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Heading = _styledComponents2.default.h3(_templateObject, function (props) {
	  return props.inverse ? props.theme.white : props.theme.black;
	}, function (props) {
	  return props.bigger ? '1.85rem' : '1.35rem';
	}, _style.media.tablet(_templateObject2, function (props) {
	  return props.bigger ? '3rem' : '1.75rem';
	}));
	
	var H3 = function H3(_ref) {
	  var children = _ref.children,
	      otherProps = _objectWithoutProperties(_ref, ['children']);
	
	  return _react2.default.createElement(
	    Heading,
	    otherProps,
	    children
	  );
	};
	
	H3.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = H3;
	module.exports = exports['default'];

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: ', ';\n  line-height: 1.2;\n  margin: 0 0 10px;\n\n  ', ';\n'], ['\n  color: ', ';\n  font-size: ', ';\n  line-height: 1.2;\n  margin: 0 0 10px;\n\n  ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    font-size: ', ';\n  '], ['\n    font-size: ', ';\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _style = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Heading = _styledComponents2.default.h4(_templateObject, function (props) {
	  return props.light ? props.theme.gray : props.inverse ? props.theme.white : props.theme.black;
	}, function (props) {
	  return props.bigger ? '1.4rem' : props.big ? '1.3rem' : '1.25rem';
	}, _style.media.tablet(_templateObject2, function (props) {
	  return props.bigger ? '1.85rem' : props.big ? '1.65rem' : '1.4rem';
	}));
	
	var H4 = function H4(_ref) {
	  var children = _ref.children,
	      otherProps = _objectWithoutProperties(_ref, ['children']);
	
	  return _react2.default.createElement(
	    Heading,
	    otherProps,
	    children
	  );
	};
	
	H4.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = H4;
	module.exports = exports['default'];

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  &:after {\n    background-color: rgba(0, 0, 0, 0.05);\n    bottom: 0;\n    content: \'\';\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 100%;\n  }\n'], ['\n  &:after {\n    background-color: rgba(0, 0, 0, 0.05);\n    bottom: 0;\n    content: \'\';\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 100%;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background: ', ';\n  bottom: 0;\n  left: 0;\n  padding: 35px 10px 10px;\n  position: absolute;\n  right: 0;\n  text-align: left;\n  transition: padding 0.35s;\n\n  p {\n    margin: 0;\n  }\n'], ['\n  background: ', ';\n  bottom: 0;\n  left: 0;\n  padding: 35px 10px 10px;\n  position: absolute;\n  right: 0;\n  text-align: left;\n  transition: padding 0.35s;\n\n  p {\n    margin: 0;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin: 15px auto;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  ', ' ', '\n\n  a {\n    display: block;\n\n    &:hover,\n    &:focus {\n      ', ' {\n        padding-bottom: 20px;\n        padding-top: 25px;\n      }\n    }\n  }\n'], ['\n  margin: 15px auto;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  ', ' ', '\n\n  a {\n    display: block;\n\n    &:hover,\n    &:focus {\n      ', ' {\n        padding-bottom: 20px;\n        padding-top: 25px;\n      }\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n          max-width: 350px;\n        '], ['\n          max-width: 350px;\n        ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    margin: 0 0.5%;\n    width: ', ';\n  '], ['\n    margin: 0 0.5%;\n    width: ', ';\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _style = __webpack_require__(7);
	
	var _H = __webpack_require__(18);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _P = __webpack_require__(11);
	
	var _P2 = _interopRequireDefault(_P);
	
	var _ResponsiveImg = __webpack_require__(34);
	
	var _ResponsiveImg2 = _interopRequireDefault(_ResponsiveImg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ProjectImg = _styledComponents2.default.div(_templateObject);
	
	var ProjectCopy = _styledComponents2.default.div(_templateObject2, function (props) {
	  return 'linear-gradient(transparent, rgba(0, 0, 0, .7), ' + props.theme.black + ')';
	});
	
	var ProjectWrap = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.portrait ? (0, _styledComponents.css)(_templateObject4) : '';
	}, _style.media.desktop(_templateObject5, function (props) {
	  return props.portrait ? '24%' : '49%';
	}), ProjectCopy);
	
	var Project = function Project(_ref) {
	  var link = _ref.link,
	      title = _ref.title,
	      description = _ref.description,
	      image = _ref.image,
	      portrait = _ref.portrait;
	  return _react2.default.createElement(
	    ProjectWrap,
	    { portrait: portrait },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: link, title: 'Visit ' + title + ' Project Page' },
	      _react2.default.createElement(
	        ProjectImg,
	        null,
	        _react2.default.createElement(_ResponsiveImg2.default, { src: image, alt: description })
	      ),
	      _react2.default.createElement(
	        ProjectCopy,
	        null,
	        _react2.default.createElement(
	          _H2.default,
	          { inverse: true },
	          title
	        ),
	        _react2.default.createElement(
	          _P2.default,
	          { inverse: true },
	          description
	        )
	      )
	    )
	  );
	};
	
	Project.propTypes = {
	  link: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.string.isRequired
	};
	
	exports.default = Project;
	module.exports = exports['default'];

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  background-color: ', ';\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  margin: 5px auto;\n  padding: 10px;\n  height: 100px;\n  width: 100px;\n'], ['\n  align-items: center;\n  background-color: ', ';\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  margin: 5px auto;\n  padding: 10px;\n  height: 100px;\n  width: 100px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: block;\n  flex-grow: 1;\n  padding: 50px 20px 10px;\n  text-align: left;\n  transition: padding 0.35s;\n\n  p {\n    margin: 0;\n  }\n'], ['\n  display: block;\n  flex-grow: 1;\n  padding: 50px 20px 10px;\n  text-align: left;\n  transition: padding 0.35s;\n\n  p {\n    margin: 0;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  box-sizing: border-box;\n  display: flex;\n  margin: 15px auto;\n  max-width: 350px;\n  position: relative;\n  text-align: center;\n  width: 100%;\n\n  ', ' &:before {\n    background-image: ', ';\n    border-radius: 0 0 100% 100%;\n    content: \'\';\n    height: 130px;\n    position: absolute;\n    width: 100%;\n    z-index: 1;\n  }\n\n  a {\n    display: block;\n    position: relative;\n    text-decoration: none;\n    width: 100%;\n    z-index: 2;\n\n    &:hover,\n    &:focus {\n      ', ' {\n        padding-bottom: 20px;\n        padding-top: 40px;\n      }\n    }\n  }\n'], ['\n  background-color: ', ';\n  box-sizing: border-box;\n  display: flex;\n  margin: 15px auto;\n  max-width: 350px;\n  position: relative;\n  text-align: center;\n  width: 100%;\n\n  ', ' &:before {\n    background-image: ', ';\n    border-radius: 0 0 100% 100%;\n    content: \'\';\n    height: 130px;\n    position: absolute;\n    width: 100%;\n    z-index: 1;\n  }\n\n  a {\n    display: block;\n    position: relative;\n    text-decoration: none;\n    width: 100%;\n    z-index: 2;\n\n    &:hover,\n    &:focus {\n      ', ' {\n        padding-bottom: 20px;\n        padding-top: 40px;\n      }\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    margin: 0 0.5%;\n    width: 29%;\n  '], ['\n    margin: 0 0.5%;\n    width: 29%;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _style = __webpack_require__(7);
	
	var _H = __webpack_require__(18);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _P = __webpack_require__(11);
	
	var _P2 = _interopRequireDefault(_P);
	
	var _ResponsiveImg = __webpack_require__(34);
	
	var _ResponsiveImg2 = _interopRequireDefault(_ResponsiveImg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ProjectImg = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.projectNoImage;
	});
	
	var ProjectCopy = _styledComponents2.default.div(_templateObject2);
	
	var ProjectWrap = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.theme.projectNoImage;
	}, _style.media.desktop(_templateObject4), function (props) {
	  return 'url("data:image/svg+xml,%3Csvg width=\'6\' height=\'6\' viewBox=\'0 0 6 6\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'%23' + props.theme.projectNoImagePattern + '\' fill-opacity=\'0.25\' fill-rule=\'evenodd\'%3E%3Cpath d=\'M5 0h1L0 6V5zM6 5v1H5z\'/%3E%3C/g%3E%3C/svg%3E")';
	}, ProjectCopy);
	
	var ProjectWithNoImage = function ProjectWithNoImage(_ref) {
	  var link = _ref.link,
	      title = _ref.title,
	      description = _ref.description,
	      image = _ref.image;
	  return _react2.default.createElement(
	    ProjectWrap,
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: link, title: 'Visit ' + title + ' Project Page' },
	      _react2.default.createElement(
	        ProjectImg,
	        null,
	        _react2.default.createElement(_ResponsiveImg2.default, { src: image, alt: description })
	      ),
	      _react2.default.createElement(
	        ProjectCopy,
	        null,
	        _react2.default.createElement(
	          _H2.default,
	          { inverse: true },
	          title
	        ),
	        _react2.default.createElement(
	          _P2.default,
	          { inverse: true },
	          description
	        )
	      )
	    )
	  );
	};
	
	ProjectWithNoImage.propTypes = {
	  link: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.string.isRequired
	};
	
	exports.default = ProjectWithNoImage;
	module.exports = exports['default'];

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: ', ';\n  text-align: center;\n'], ['\n  padding: ', ';\n  text-align: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-bottom: 25px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 10px;\n  padding-right: 10px;\n  text-align: center;\n  width: 100%;\n\n  ', ';\n'], ['\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-bottom: 25px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 10px;\n  padding-right: 10px;\n  text-align: center;\n  width: 100%;\n\n  ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    flex-wrap: nowrap;\n  '], ['\n    flex-wrap: nowrap;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _style = __webpack_require__(7);
	
	var _H = __webpack_require__(27);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _H3 = __webpack_require__(50);
	
	var _H4 = _interopRequireDefault(_H3);
	
	var _P = __webpack_require__(11);
	
	var _P2 = _interopRequireDefault(_P);
	
	var _Project = __webpack_require__(95);
	
	var _Project2 = _interopRequireDefault(_Project);
	
	var _ProjectWithNoImage = __webpack_require__(96);
	
	var _ProjectWithNoImage2 = _interopRequireDefault(_ProjectWithNoImage);
	
	var _compareMovies = __webpack_require__(69);
	
	var _compareMovies2 = _interopRequireDefault(_compareMovies);
	
	var _nagMe = __webpack_require__(70);
	
	var _nagMe2 = _interopRequireDefault(_nagMe);
	
	var _react3 = __webpack_require__(152);
	
	var _react4 = _interopRequireDefault(_react3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Headings = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.projectPage ? '0 10px 20px' : '40px 10px 20px';
	});
	
	var Projects = _styledComponents2.default.div(_templateObject2, _style.media.desktop(_templateObject3));
	
	exports.default = function (_ref) {
	  var projectPage = _ref.projectPage;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      Headings,
	      { projectPage: projectPage },
	      projectPage ? _react2.default.createElement(
	        _H2.default,
	        { bigger: true },
	        'Projects'
	      ) : _react2.default.createElement(
	        _H4.default,
	        { bigger: true },
	        'Projects'
	      ),
	      _react2.default.createElement(
	        _P2.default,
	        { bigger: true },
	        'A collection of my open-source works and recent projects'
	      )
	    ),
	    _react2.default.createElement(
	      Projects,
	      null,
	      _react2.default.createElement(_ProjectWithNoImage2.default, {
	        link: '/projects/react-shorten',
	        title: 'React Shorten',
	        description: 'React component to shorten text',
	        image: _react4.default
	      }),
	      _react2.default.createElement(_Project2.default, {
	        link: '/projects/compare-movies',
	        title: 'Compare Movies',
	        description: 'Compare Movies and TV Shows Instantly',
	        image: _compareMovies2.default
	      }),
	      _react2.default.createElement(_Project2.default, {
	        portrait: true,
	        link: '/projects/nag-me',
	        title: 'Nag Me',
	        description: 'Browser extension to nag users',
	        image: _nagMe2.default
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/compare-movies.fb04962c.jpg";

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nag-me.7c04e4a1.jpg";

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProjectComponents = __webpack_require__(97);
	
	var _ProjectComponents2 = _interopRequireDefault(_ProjectComponents);
	
	var _Helmet = __webpack_require__(51);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_Helmet2.default, {
	      title: 'Gowtham Selvaraj (Gauti) Projects',
	      description: 'A collection of my open-source works and recent projects',
	      path: '/projects'
	    }),
	    _react2.default.createElement(_ProjectComponents2.default, { projectPage: true })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-b8e3686268f36ad2b34f.js